/* Block: About JS */

const initStats = () => {
    const items = document.querySelectorAll('[data-stat="stat"]');
    if (!items.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animateValue = (el, end, duration = 700) => {
        const startTime = performance.now();

        const tick = now => {
            const progress = Math.min((now - startTime) / duration, 1);
            el.textContent = Math.round(end * progress);
            if (progress < 1) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const card = entry.target;
                if (card.dataset.done === '1') return;
                card.dataset.done = '1';

                const numberEl = card.querySelector('.value.data');
                if (!numberEl) return;

                const end = parseInt(numberEl.dataset.value, 10);

                if (prefersReducedMotion) {
                    numberEl.textContent = end;
                } else {
                    animateValue(numberEl, end);
                }

                observer.unobserve(card);
            });
        },
        { threshold: 0.4 }
    );

    items.forEach(item => observer.observe(item));
};

document.addEventListener('DOMContentLoaded', initStats);
